import React, { useState } from "react";
import classes from "./style.module.scss";
import useTranslation from "~/app/hooks/useTranslation";
import LineTypeIcon from "~/workorder/Detail/LineTypeIcon";
import { IssueOrServiceType } from "~/app/data/statuses/chat";
import { Material } from "~/types";
import MaterialRowMenu from "~/materials/MaterialRowMenu";
import { formatMaterialPrice, isVariousMaterial } from "~/materials/helper";

interface ListItemProps {
  material: Material;
  canEdit: boolean;
  onEdit: (material: Material) => void;
  onRemove: (material: Material) => void;
}

export type ListItemComponent = React.FC<ListItemProps>;

const ListItem: ListItemComponent = ({ material, canEdit, onEdit, onRemove }) => {
  const { t: tParts } = useTranslation("parts");
  const [showFullComment, setShowFullComment] = useState(false);

  const displayName = isVariousMaterial(material)
    ? tParts("variousMaterial")
    : (material.name ?? "");

  const comment = material.comment ?? "";
  const isLongComment = comment.length > 30;
  const displayedComment = isLongComment && !showFullComment ? `${comment.slice(0, 30)}...` : comment;

  return (
    <div className={classes["list-row"]}>
      {material.fromType !== undefined && (
        <LineTypeIcon
          type={material.fromType as IssueOrServiceType}
          issueId={material.issueId ?? 0}
        />
      )}
      <div className={classes["row-content"]}>
        <div className={classes["row-main"]}>
          <p className={classes["row-name"]}>{displayName}</p>
        </div>
        <p className={classes["row-meta"]}>
          {material.categoryName ? `${material.categoryName} · ` : ""}
          {formatMaterialPrice(Number(material.pricePerUnit) || 0)}
          {" · "}
          {material.quantity} {tParts("item")}
        </p>
        {comment && (
          <p className={classes["row-comment"]}>
            {displayedComment}
            {isLongComment && (
              <button
                type="button"
                className={classes["show-more-btn"]}
                onClick={() => setShowFullComment((prev) => !prev)}
              >
                {showFullComment ? "Show less" : "Show more"}
              </button>
            )}
          </p>
        )}
      </div>
      <div className={classes["row-actions"]}>
        {canEdit && (
          <MaterialRowMenu
            material={material}
            onEdit={onEdit}
            onRemove={onRemove}
          />
        )}
      </div>
    </div>
  );
};

export default ListItem;